import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WorkspaceDemo.css';
import blueShieldImg from '../../assets/blueshield.png';

const WorkspaceDemo = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="main-hero demo-hero wsdemo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
      </section>

      <section className="wsdemo-content">
        <div className="wsdemo-layout">

          <div className="wsdemo-video-wrap">
            <div style={{ position: 'relative', overflow: 'hidden', aspectRatio: '1920/1080' }}>
              <iframe
                src="https://share.synthesia.io/embeds/videos/f6271f89-d62b-4540-9f85-066a525e9635"
                loading="lazy"
                title="Synthesia video player - Bltz Workspace"
                allowFullScreen
                allow="encrypted-media; fullscreen; microphone; screen-wake-lock;"
                style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, border: 'none', padding: 0, margin: 0, overflow: 'hidden' }}
              />
            </div>
          </div>

          <div className="wsdemo-cta">
            <button className="wsdemo-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Get a Live Demo &rarr;
            </button>
            <button className="wsdemo-cta-btn wsdemo-cta-btn-outline" onClick={() => { navigate('/ai-governance'); window.scrollTo(0, 0); }}>
              Explore Bltz Workspace &rarr;
            </button>
          </div>

          <span className="wsdemo-back-link" onClick={() => { navigate('/'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            &larr; Back to Home
          </span>
        </div>
      </section>
    </>
  );
};

export default WorkspaceDemo;
